import React from 'react';

const UnlockImminent = ({ children }) => {
  return (
    <div className='ds-card'>
      <div className='cardList' data-testid='unlock-imminent-util-card'>
        {children}
      </div>
    </div>
  );
}

export default UnlockImminent;



// WEBPACK FOOTER //
// ./src/features/CreditLimit/components/utilization/UnlockImminent.js